import { Space } from 'antd';
import { NewTag } from 'components/elements';
import dayjs from 'dayjs';
import { getAmountWithComma } from 'utils/utils';

const ProductItem = ({ item, soldout = true, onClick }) => {
  const handleClick = () => {
    if (onClick) onClick();
  };

  return (
    <div style={{ width: '198px', height: 'auto', border: '1px solid var(--color-gray10)', cursor: onClick && 'pointer' }} onClick={handleClick}>
      <img src={item?.PRODUCT_THUMBNAIL_PATH} alt={'대표 이미지'} style={{ width: '196px', height: '162px', objectFit: 'contain' }} />

      <div style={{ textAlign: 'center', padding: '10px 0' }}>
        <Space direction={'vertical'} size={7}>
          <span
            className="text-red"
            style={{
              fontSize: '14px',
              visibility: !soldout ? 'hidden' : item?.INVENTORY_EA && item?.INVENTORY_EA >= item?.SAFE_INVENTORY_EA ? 'hidden' : 'visible'
            }}
          >
            &#91;품절임박&#93;
          </span>

          <Space direction={'vertical'} size={10}>
            <Space size={0}>
              <span style={{ fontSize: '14px', fontWeight: 600, display: 'block', maxWidth: '160px', wordBreak: 'keep-all' }}>
                {item?.PRODUCT_NAME}
              </span>
              {dayjs(item?.CREATE_DATE).isSame(dayjs(), 'day') && <NewTag />}
            </Space>

            <Space direction={'vertical'}>
              {item?.DISCOUNT_YN === 1 && <div style={{ fontSize: '14px', fontWeight: 600, textDecoration: 'line-through' }}>{getAmountWithComma(item?.BASIC_PRICE)}원</div>}
              {item?.DISCOUNT_YN === 1 && (item?.DISCOUNT_RATE ? <div style={{ color: 'var(--color-red04)' }}>{item?.DISCOUNT_RATE}% 할인</div> : <div style={{ color: 'var(--color-red04)' }}>{item?.DISCOUNT_PRICE}원 할인</div>)}
              <div style={{ fontSize: '14px', fontWeight: 500 }}>{getAmountWithComma(item?.SALE_PRICE)}원</div>
            </Space>
          </Space>
        </Space>
      </div>
    </div>
  );
};

export default ProductItem;
